import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../contexts/Web3StatusContext";
import TransactionStatus from '../TransactionStatus'

const { AccountData, ContractData, ContractForm } = newContextComponents;

class Finalize extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    amount: 0,
    stackId: -1,
    finalizedDataKey: null,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
  
    // let drizzle know we want to watch the `myString` method
    const finalizedDataKey = contract.methods["finalized"].cacheCall();
    // save the `dataKey` to local component state for later reference
    this.setState({ finalizedDataKey:finalizedDataKey });
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    const finalizedFromContract =
      this.props.drizzleState.contracts.GAMEFORESTSale["finalized"]
      [this.state.finalizedDataKey];

    if(finalizedFromContract !== undefined) {
      if(!finalizedFromContract.value) {
        const stackId = GAMEFORESTSale.methods.finalizePublic.cacheSend();
        this.setState({ stackId: stackId });
      }
      else {
        const stackId = GAMEFORESTSale.methods.setFinalized.cacheSend(false);
        this.setState({ stackId: stackId });
      }
    }
  }

  // destructure drizzle and drizzleState from props
  render() {
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    var disabled = this.context.activeAccount == null;

    var finalized = false;
    var caption = "Finalize";
    var warning = '';
    const finalizedFromContract =
      GAMEFORESTSale["finalized"][this.state.finalizedDataKey];

    if(finalizedFromContract !== undefined) {
      finalized = finalizedFromContract.value;
      if(finalized) {
        disabled = true;
        caption = "set finalized false";
        warning = (
        <div style={{ color: 'red'}}>
          already finalized, you are reversing
        </div>
        );
      }
    }
    else {
      disabled = true;
    }

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        {statusMsg}<br/>
        {warning}
        <input
        type='submit'
        value={caption}
        disabled={disabled}
        />
    </form>
    );

    return (
      <div>
        {form}
      </div>
    );
  }
};

export default Finalize;
